var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { useDeleteDevice, useDislikeTrackDevice, usePlayDevice, usePlayNextTrackDevice, useRefreshDevice, useStopDevice, useUpdateDevice, } from "frontend/src/domain/devices";
import { paths } from "frontend/src/pages/paths/index";
export var usePageDeviceId = function () {
    var id = useParams().id;
    return Number(id);
};
var validate = function (form) {
    var isValid = true;
    var errors = {};
    if (form.title.length === 0) {
        errors.title = "Заполните поле.";
        isValid = false;
    }
    return {
        isValid: isValid,
        errors: errors,
        validated: { title: form.title, timetableId: form.timetableId },
    };
};
export var useEditDevice = function (_a) {
    var _b, _c;
    var device = _a.device, id = _a.id;
    var update = useUpdateDevice();
    var _d = React.useState((_b = device === null || device === void 0 ? void 0 : device.title) !== null && _b !== void 0 ? _b : ""), title = _d[0], setTitle = _d[1];
    var _e = React.useState((_c = device === null || device === void 0 ? void 0 : device.timetableId) !== null && _c !== void 0 ? _c : ""), timetableId = _e[0], setTimetableId = _e[1];
    var _f = React.useState({}), errors = _f[0], setErrors = _f[1];
    var submit = function (evt) {
        evt.preventDefault();
        var _a = validate({ title: title, timetableId: timetableId }), validated = _a.validated, errors = _a.errors, isValid = _a.isValid;
        if (!isValid) {
            setErrors(errors);
            return;
        }
        setErrors({});
        update.mutate(__assign(__assign({}, validated), { id: id }));
    };
    var onTitleChange = function (evt) {
        return setTitle(evt.target.value);
    };
    var onTimetableIdChange = function (evt) {
        var value = evt.target.value;
        if (typeof value === "number") {
            setTimetableId(value);
        }
    };
    return {
        title: {
            value: title,
            error: errors.title,
            onChange: onTitleChange,
        },
        timetableId: {
            value: timetableId,
            onChange: onTimetableIdChange,
        },
        submit: submit,
        pending: update.isLoading,
    };
};
export var useControlDevice = function (id) {
    var play = usePlayDevice();
    var stop = useStopDevice();
    var playNextTrack = usePlayNextTrackDevice();
    var dislike = useDislikeTrackDevice();
    var refresh = useRefreshDevice(id);
    return {
        play: {
            run: function () { return play.mutate(id); },
            isLoading: play.isLoading,
        },
        stop: {
            run: function () { return stop.mutate(id); },
            isLoading: stop.isLoading,
        },
        playNextTrack: {
            run: function () { return playNextTrack.mutate(id); },
            isLoading: playNextTrack.isLoading,
        },
        dislike: {
            run: function () { return dislike.mutate(id); },
            isLoading: dislike.isLoading,
        },
        refresh: {
            run: refresh.run,
            isLoading: refresh.isLoading,
        },
    };
};
export var useDeactivatePageDevice = function (id) {
    var history = useHistory();
    var deactivate = useDeleteDevice();
    var run = function () { return deactivate.mutate(id); };
    React.useEffect(function () {
        if (deactivate.isSuccess) {
            history.push(paths.business.owner.devices.index());
        }
    }, [history, deactivate.isSuccess]);
    return { run: run, isLoading: deactivate.isLoading };
};
